import type { AppConfig, AuthConfig } from '@scansource-brazil/zeus-core-ui/types';

/**
 * Fetches config.json, then run callback.
 * @param callback
 */
async function preMount(callback: (args: any) => any) {
  try {
    return callback(prepareConfig(await fetchConfig()));
  } catch (error) {
    console.error('something wrong pre mounting:', error);
  }
}

async function fetchConfig() {
  try {
    return await fetch('/config.json').then((res) => res.json());
  } catch (error) {
    console.error('something wrong fetching config', error);
  }
}

function prepareConfig(config: any): AuthConfig & AppConfig & { featureFlagURL: string } {
  return {
    url: config.AUTH_URL,
    realm: config.REALM,
    clientId: config.CLIENT_ID,
    baseURL: config.BASE_URL,
    accountsURL: config.ACCOUNTS_URL,
    apiKey: config.API_KEY,
    featureFlagURL: config.FEATURE_FLAG_URL,
  };
}

export default preMount;
